export default "__VITE_ASSET__DlOJlVkP__"